export default __webpack_public_path__ + "static/media/visa.4a49af6e.svg";